var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('h3',[_vm._v("New Enquiries")]),_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.chartOptionsEnquiries(),"autoresize":""}}),_c('h3',[_vm._v("Value of Leads ")]),_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.chartOptionsInProgress(),"autoresize":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }